import styled from "styled-components";
import clients from "../images/clients.jpg";

const Wrapper = styled.div`
  padding: 60px 0;
  background: linear-gradient(rgba(15, 44, 89, 0.94), rgba(15, 44, 89, 0.88)),
    url(${clients});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @media (min-width: 768px) {
    background-attachment: fixed;
  }

  overflow-x: hidden;

  .container {
    padding: 0 20px;
    
    h3 {
      text-align: center;
      color: var(--secondary-color);
      margin-bottom: 60px;
      font-size: 2rem; /* Increased size */
    }
    .icon-quote {
      font-size: 50px;
      color: var(--secondary-color);
    }
    
    .client {
      background: rgba(255, 255, 255, 0.05); /* very subtle white tint instead of dark overlay on dark bg */
      backdrop-filter: blur(5px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      
      min-height: 250px; /* Ensure consistency */
      max-width: 570px;
      display: flex !important;
      flex-direction: column;
      justify-content: space-between;
      padding: 30px 25px;
      border-radius: var(--radius);
      margin: 0 10px; /* Spacing between slides */

      @media (max-width: 600px) {
        justify-content: center;
        min-height: 260px;
        padding-bottom: 30px;
        text-align: center;
      }

      .star-icon-container {
        margin: 15px 0 10px;

        .star-icon {
          color: var(--secondary-color); /* Gold stars */
          font-size: 1.2rem;
          margin-right: 2px;
        }
      }

      h4 {
        color: var(--secondary-color);
        align-self: flex-start;
        font-family: 'Playfair Display', serif;
        font-size: 1.2rem;
        letter-spacing: 1px;
        
        @media (max-width: 600px) {
           align-self: center;
        }
      }

      p {
        font-size: 1.1rem;
        color: #f1f1f1;
        letter-spacing: 0.5px;
        font-style: italic;
        line-height: 1.6;
        font-family: 'Lato', sans-serif;
      }
    }
    
    /* Slick dots customization */
    .slick-dots li button:before {
      color: white;
    }
    .slick-dots li.slick-active button:before {
      color: var(--secondary-color);
    }
  }
`;

export default Wrapper;
